import React, { useState } from 'react';
import { Eye, EyeOff, Lock, Loader2, CheckCircle, ShieldCheck } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../utils/api';

export default function AlterarSenha() {
  const [form, setForm] = useState({ atual: '', nova: '', confirmar: '' });
  const [ver,  setVer]  = useState({ atual: false, nova: false });
  const [salvando, setSalvando] = useState(false);
  const [ok,       setOk]       = useState(false);

  const campo = (k) => ({
    value:    form[k],
    onChange: e => { setForm(p => ({...p, [k]: e.target.value})); setOk(false); },
  });

  const forca = (s) => {
    let n = 0;
    if (s.length >= 8)         n++;
    if (/[A-Z]/.test(s))       n++;
    if (/[0-9]/.test(s))       n++;
    if (/[^A-Za-z0-9]/.test(s))n++;
    return n; // 0-4
  };

  const forcaTexto = [null, 'Fraca', 'Razoável', 'Boa', 'Forte'];
  const forcaCor   = ['', 'bg-red-400', 'bg-yellow-400', 'bg-lime-500', 'bg-green-500'];
  const f = forca(form.nova);

  const salvar = async (e) => {
    e.preventDefault();
    if (!form.atual) return toast.error('Informe sua senha atual.');
    if (form.nova.length < 8) return toast.error('Nova senha deve ter no mínimo 8 caracteres.');
    if (form.nova !== form.confirmar) return toast.error('As senhas não coincidem.');

    setSalvando(true);
    try {
      const { data } = await api.post('/auth/alterar-senha', {
        senha_atual: form.atual,
        senha_nova:  form.nova,
      });
      toast.success(data.mensagem || 'Senha alterada!');
      setForm({ atual: '', nova: '', confirmar: '' });
      setOk(true);
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Erro ao alterar senha.');
    }
    setSalvando(false);
  };

  return (
    <div className="card p-5 border-2 border-gray-100">
      <div className="flex items-center gap-2 mb-4">
        <ShieldCheck size={16} className="text-acre-green"/>
        <h2 className="section-title mb-0">Alterar Senha</h2>
      </div>

      {ok && (
        <div className="flex items-center gap-2 bg-green-50 border border-green-200 rounded-xl p-3 mb-4">
          <CheckCircle size={15} className="text-green-500"/>
          <p className="text-sm text-green-700 font-medium">Senha alterada com sucesso!</p>
        </div>
      )}

      <form onSubmit={salvar} className="space-y-4">
        {/* Senha atual */}
        <div>
          <label className="label">Senha atual *</label>
          <div className="relative">
            <input className="input pr-10"
              type={ver.atual ? 'text' : 'password'}
              placeholder="Sua senha atual"
              {...campo('atual')} required/>
            <button type="button" onClick={() => setVer(v => ({...v, atual: !v.atual}))}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
              {ver.atual ? <EyeOff size={14}/> : <Eye size={14}/>}
            </button>
          </div>
        </div>

        {/* Nova senha */}
        <div>
          <label className="label">Nova senha *</label>
          <div className="relative">
            <input className="input pr-10"
              type={ver.nova ? 'text' : 'password'}
              placeholder="Mínimo 8 caracteres"
              {...campo('nova')} required minLength={8}/>
            <button type="button" onClick={() => setVer(v => ({...v, nova: !v.nova}))}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600">
              {ver.nova ? <EyeOff size={14}/> : <Eye size={14}/>}
            </button>
          </div>
          {/* Força da senha */}
          {form.nova && (
            <div className="mt-1.5 space-y-1">
              <div className="flex gap-1">
                {[1,2,3,4].map(i => (
                  <div key={i} className={`h-1 flex-1 rounded-full transition-colors ${f >= i ? forcaCor[f] : 'bg-gray-100'}`}/>
                ))}
              </div>
              <div className="flex justify-between text-xs">
                <div className="flex gap-2">
                  <span className={form.nova.length>=8 ? 'text-green-500' : 'text-gray-400'}>✓ 8+ chars</span>
                  <span className={/[A-Z]/.test(form.nova) ? 'text-green-500' : 'text-gray-400'}>✓ Maiúscula</span>
                  <span className={/[0-9]/.test(form.nova) ? 'text-green-500' : 'text-gray-400'}>✓ Número</span>
                </div>
                <span className={`font-semibold ${['','text-red-500','text-yellow-600','text-lime-600','text-green-600'][f]}`}>
                  {forcaTexto[f]}
                </span>
              </div>
            </div>
          )}
        </div>

        {/* Confirmar */}
        <div>
          <label className="label">Confirmar nova senha *</label>
          <input
            className={`input ${form.confirmar && form.confirmar !== form.nova ? 'border-red-400 focus:border-red-500' : form.confirmar && form.confirmar === form.nova ? 'border-green-400 focus:border-green-500' : ''}`}
            type={ver.nova ? 'text' : 'password'}
            placeholder="Repita a nova senha"
            {...campo('confirmar')} required/>
          {form.confirmar && form.confirmar !== form.nova && (
            <p className="text-xs text-red-500 mt-1">As senhas não coincidem</p>
          )}
        </div>

        <button type="submit"
          disabled={salvando || !form.atual || form.nova.length < 8 || form.nova !== form.confirmar}
          className="btn-primary w-full justify-center py-3 flex items-center gap-2 disabled:opacity-60">
          {salvando ? <Loader2 size={14} className="animate-spin"/> : <Lock size={14}/>}
          Salvar nova senha
        </button>
      </form>
    </div>
  );
}
